export default  {
  require: {
    ngModel: 'ngModel'
  },
  bindings: {
    categorylist: '<'
  },
  controller: 'categorySelectController',
  template: require('../views/category.select.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/components/category.select.component.js